module.exports = __webpack_public_path__ + "r-v3/img/emoti-crying.c770e38c.svg";